import React from "react";
import {ICardProject} from '../interfaces/ICardProject';
import { useNavigate } from "react-router-dom";
import '../styles/Card.css';

const Card = (projectData: ICardProject) => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(`/projectDetail/${projectData.id}`);
        
    }

    return (
        <div className="card-project" onClick={handleClick}>
            <picture>
                <img src={projectData.image} alt={projectData.title} />
            </picture>
            <div className="card-content">
                <h3>{projectData.title}</h3>
                <p>{projectData.description}</p>
                <div className="tech-chips">
                {projectData.tech.map((t) => (
                    <span key={t} className="chip">{t}</span>
                ))}
                </div>
            </div>
        </div>
    )
}

export default Card;